/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Event_Group_Option_LabelInputs */



/**
* | output |
* | --- |
* | "{name} ({count} events)" |
*
* @param {Event_Group_Option_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_option_label = /** @type {((inputs: Event_Group_Option_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Option_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} (${i?.count} événements)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} (${i?.count} Ereignisse)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} (eventi ${i?.count})`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.name} (${i?.count} события)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} (${i?.count} eventos)`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.name}（${i?.count} 事件）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} (${i?.count} イベント)`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} (${i?.count} घटनाएँ)`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.name} (eventos ${i?.count})`)
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.count} events)`)
});